import { Typography, useMediaQuery } from "@mui/material";
import { useDispatch } from "react-redux";
import { dashboard } from "../../../store/dashboardSlice";
import { useSelector } from "react-redux";
import { useEffect } from "react";

export default function ProductName({ productName }) {
    // const dispatch = useDispatch();
    // const { data, status } = useSelector((state) => state.dashboard);
    const isMobile = useMediaQuery('(max-width:600px)');
  
    // useEffect(() => {
    //   dispatch(dashboard());
    // }, []);
  
    // const {
    //   customer_name,
    //   customer_id,
    //   products,
    //   client_status,
    //   client_email,
    // } = data;

    if (isMobile) {
      return null;
    }

    return (
        <Typography color={"black"} variant="h6">
          Products taken: {productName}
        </Typography>
    );   
}
